import { useState } from "react";
import Nav from "./components/Nav";
import Panel1 from "./components/Panel1";
import Panel2 from "./components/Panel2";

export default function Wallet() {
  const [active, setActive] = useState(2);
  return (
    <>
      <Nav
        active={active}
        onClick={(index) => {
          setActive(index);
        }}
      />
      {active === 1 ?<Panel1 /> :<Panel2 />}
    </>
  );
}
